export const OverviewHeaderLabels = {
  selectAccount: `Select Account`,
  selectProject: `Select Journey`,
  adminPanelTitle: 'Welcome Admin!',
  adminPanelLogout: 'Logout from DCA',
  profileSettings: 'My Profile Settings',
  userManagement: 'User Management',
  projectManagement: 'Account & Project Management',
  genAiButton: 'Gen AI Search',
};
